import moment from 'moment';
import { getEstimateTenderStatuses } from '../../HttpRequests/estimateTenderStatuses';
import { loadEstimateTenderStatuses } from '../State/estimateTenderStatuses';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getEstimateTenderStatuses();

    dispatch(loadEstimateTenderStatuses(response.data.data));

  } catch (error) {
    
    throw error;

  }
}